<template>

</template>
<script>
  export default {
    beforeRouteEnter(to, from, next) {
      next(vm => {
        //   console.log(to)
        vm.$router.replace(to.query.url)
      })
    },
    // 变量定义
    data() {
      return {

      }
    },

    created() {

    },
    methods: {

    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/kong.vue